
define('text!libs/strand/src/strand-currency/example.html',[],function () { return '<strand-currency currency="ISK" value="2000"></strand-currency>\n<strand-currency currency="CHF" value="2000"></strand-currency>\n<strand-currency currency="GBP" value="2000"></strand-currency>\n<strand-currency value="2000"></strand-currency>';});

